import React, { useEffect, useState } from 'react'
import { corporateColor, white } from '../../../../theme/colors'
import { StyleSheet, Text, View } from 'react-native'
import { Separator } from '../../../../components/Separator'
import { TextInputComponent } from '../../../../components/TextInputComponent'
import { Header } from './Header'
import { Item } from './Item'
import { FuelTankReq, NavalArtifact, NavalArtifactReq } from '../types'
import { useForm } from '../../../../hooks/useForm'
import { DOBRA } from '../../../../theme/fonts'

interface Props {
  item: NavalArtifact
  onChange: (values: NavalArtifactReq) => void
}

interface FuelTankItem {
  [fuelTankId: number]: FuelTankReq
}

export const Card = ({ item, onChange }: Props) => {
  const [values, setValues] = useState<FuelTankItem>({})
  const { values: form, onChangeValues } = useForm({ total: '', stock: 0 })

  const handleOnChange = (values: { fuelTankId: number; stock: string }) => {
    setValues((prev) => {
      return {
        ...prev,
        [values.fuelTankId]: {
          id_fuel_tank: values.fuelTankId,
          stock: values.stock,
        },
      }
    })
  }

  const formatData = () => {
    const items: FuelTankReq[] | undefined = Object.values(values)

    if (!items) return

    const format: NavalArtifactReq = {
      fuel_consumption: +form.total,
      id_naval_artifact: item.id_naval_artifact,
      fuel_tanks: items.map((item) => ({
        id_fuel_tank: item.id_fuel_tank,
        stock: item.stock,
      })),
    }
    onChange(format)
  }

  useEffect(() => {
    formatData()
  }, [values, form])

  return (
    <View style={style.cardContainer}>
      <Text style={style.title}>{item.name}</Text>
      <Separator />

      <Header />

      {item.fuel_tanks.map((fuelTank) => (
        <Item
          key={fuelTank.id_fuel_tank}
          fuelTank={fuelTank}
          onChange={handleOnChange}
          value={values[fuelTank.id_fuel_tank]?.stock ?? ''}
        />
      ))}

      <View style={{ flexDirection: 'row', marginBottom: 24 }}>
        <View style={{ flex: 2 }} />

        <View style={{ flex: 1 }}>
          <Text style={style.subTitle}>Total</Text>
        </View>
        <View style={{ flex: 1 }}>
          <Text style={style.subTitle}>
            {(Object.values(values) as FuelTankReq[])
              .reduce((acc, item) => (acc += +item.stock), 0)
              .toLocaleString('es-ES')}
          </Text>
        </View>
      </View>
      <Separator />

      <TextInputComponent
        label='Ingrese consumo diario de combustible'
        onChange={(value) => onChangeValues({ name: 'total', value })}
        value={form.total}
        keyboardType='numeric'
        maxLength={4}
      />
    </View>
  )
}

const style = StyleSheet.create({
  cardContainer: {
    backgroundColor: white,
    borderRadius: 10,
    paddingHorizontal: 16,
    paddingVertical: 24,
    gap: 8,
    marginBottom: 16,
  },

  title: {
    fontFamily: DOBRA,
    fontWeight: '500',
    fontSize: 18,
    lineHeight: 20,
    color: corporateColor,
  },
  subTitle: {
    fontFamily: DOBRA,
    fontWeight: '500',
    fontSize: 16,
    lineHeight: 20,
    color: corporateColor,
  },

  bodyLabel: {
    color: corporateColor,
    fontFamily: DOBRA,
    fontSize: 16,
    lineHeight: 20,
    fontWeight: '400',
  },
})
